import { Avatar, Popover } from 'antd';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
  Dropdown,
  DropdownToggle
} from 'reactstrap';

import Aside from '../Aside/Aside';

const propTypes = {
  accnt: PropTypes.bool,
};
const defaultProps = {
  accnt: false,
};

let profile = {
  name: "Admin",
  comp: "Ants.co.th",
  credits: "1000000",
};

class HeaderDropdown extends Component {

  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.handleVisibleChange = this.handleVisibleChange.bind(this);
    this.changePopover = this.changePopover.bind(this);

    this.state = {
      dropdownOpen: false,
      visible: false,
      visiblePopover: false
    };
  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
      visible: !this.state.visible
    });
  }


  changePopover() {
    this.setState({ visiblePopover: false });
  }

  handleVisibleChange(visible) {
    this.setState({ visiblePopover: visible });
  };

  dropAccnt(username) {
    return (
      <Dropdown nav isOpen={this.state.dropdownOpen} toggle={this.toggle}>
        <DropdownToggle nav>
          <Popover visible={this.state.visiblePopover} placement="bottomRight" content={<Aside {...this.props} username={username} visiblePopover={this.changePopover} />} trigger="click" overlayClassName="profile" onVisibleChange={this.handleVisibleChange}>
            <Avatar className="avatar-ants" size="large">
              <b>{username.substring(0, 2)}</b>
            </Avatar>
          </Popover>
        </DropdownToggle>
      </Dropdown>
    );
  }


  render() {
    const { username, accnt } = this.props;
    return (
      accnt ? this.dropAccnt(username) : null
    );
  }
}

HeaderDropdown.propTypes = propTypes;
HeaderDropdown.defaultProps = defaultProps;

export default HeaderDropdown;



// WEBPACK FOOTER //
// ./src/components/Header/HeaderDropdown.js